import type { TFunction } from 'i18next'

import type { DetailSearchParams } from '../model'

import { calculateNights, formatDatesHeader } from './format-dates-header'

interface GetKyrgyzstanDetailSubtitleParams {
  searchParams?: DetailSearchParams | null
  t: TFunction
}

export const getKyrgyzstanDetailSubtitle = ({
  searchParams,
  t,
}: GetKyrgyzstanDetailSubtitleParams): string => {
  const dates = formatDatesHeader(
    searchParams?.start_date,
    searchParams?.end_date,
  )
  const nights = calculateNights(
    searchParams?.start_date,
    searchParams?.end_date,
  )
  const guests =
    searchParams?.visitors_count !== undefined
      ? searchParams.visitors_count + (searchParams.children_ages?.length ?? 0)
      : undefined

  const parts: string[] = []

  if (dates) {
    parts.push(dates)
  }

  if (nights) {
    parts.push(t('kyrgyzstan_block.search_result.nights', { count: nights }))
  }

  if (guests) {
    parts.push(t('kyrgyzstan_block.search_result.guests', { count: guests }))
  }

  return parts.join(' • ')
}
